'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'flux-capacitor';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f8ba';
var svgPathData = 'M384 48c26.5 0 48 21.5 48 48l0 320c0 26.5-21.5 48-48 48L64 464c-26.5 0-48-21.5-48-48L16 96c0-26.5 21.5-48 48-48l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm256 80c26.5 0 48 21.5 48 48s-21.5 48-48 48c-11.9 0-22.8-4.4-31.2-11.6l36.4-30.3c3.4-2.8 3.9-7.9 1-11.3s-7.9-3.9-11.3-1l-36.4 30.3c-4.1-7.1-6.5-15.4-6.5-24.2 0-26.5 21.5-48 48-48zm-43.7 94.8c11.4 10.7 26.8 17.2 43.7 17.2 35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64c0 12.7 3.7 24.6 10.1 34.5l-42.1 35.1-42.1-35.1c6.4-10 10.1-21.8 10.1-34.5 0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64c16.9 0 32.2-6.5 43.7-17.2l44.3 37 0 44.7c-31.6 3.9-56 30.9-56 63.5 0 35.3 28.7 64 64 64s64-28.7 64-64c0-32.6-24.4-59.6-56-63.5l0-44.7 44.3-37zM216 304.7l0 47.3c0 4.4 3.6 8 8 8s8-3.6 8-8l0-47.3c22.7 3.8 40 23.6 40 47.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-23.8 17.3-43.5 40-47.3zM159.2 196.4c-8.4 7.2-19.3 11.6-31.2 11.6-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48c0 8.8-2.4 17.1-6.5 24.2l-36.4-30.3c-3.4-2.8-8.4-2.4-11.3 1s-2.4 8.4 1 11.3l36.4 30.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFluxCapacitor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;